import { ArrowUpFromLine, Dumbbell, ShieldCheck, Zap } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";

const SKILLS = [
    { icon: Dumbbell, title: "Get stronger and steadier", text: "Leg strength and balance that help prevent falls in the first place." },
    { icon: Zap, title: "Catch yourself", text: "Quick-reaction and stepping skills for when you trip or slip." },
    { icon: ShieldCheck, title: "Land more safely", text: "Protective habits for your head, hips and wrists, learned gradually on padded mats." },
    { icon: ArrowUpFromLine, title: "Get back up", text: "How to get up from the floor safely, and what to do if you can't." },
];

export default function Learn() {
    return (
        <section id="what-youll-learn" className="scroll-mt-24 pb-10 sm:pb-14 lg:pb-28">
            <div className="mx-auto max-w-7xl px-5 sm:px-8">
                <Reveal>
                    <SectionHead eyebrow="The skills" title="What you'll learn" />
                </Reveal>
                <div className="mt-8 grid sm:mt-12 gap-6 sm:grid-cols-2 lg:grid-cols-4">
                    {SKILLS.map((s, i) => (
                        <Reveal key={s.title} delay={i * 0.08} className="h-full">
                            <div
                                className="h-full rounded-3xl border border-clay bg-white p-5 sm:p-8 transition-[border-color,transform] duration-200 hover:-translate-y-1 hover:border-teal-600/40"
                                data-testid={`skill-card-${i + 1}`}
                            >
                                <span className="grid h-11 w-11 sm:h-14 sm:w-14 place-items-center rounded-2xl bg-teal-50 text-teal-700" aria-hidden="true">
                                    <s.icon className="h-7 w-7" />
                                </span>
                                <h3 className="mt-6 font-display text-xl font-extrabold text-ink">{s.title}</h3>
                                <p className="mt-3 text-lg leading-relaxed text-ink-soft">{s.text}</p>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}